import {ConnectorIdSchema} from '@cohort/shared/schema/apps';
import {UserPropertyValueSchema} from '@cohort/shared/schema/common/userProperty';
import {z} from 'zod';

export const ConnectionWSchema = z.object({
  id: z.string(),
  connectorId: ConnectorIdSchema,
  profile: z.object({
    id: z.string(),
    displayName: z.string(),
    properties: z.record(UserPropertyValueSchema.nullable()),
  }),
});
export type ConnectionWDto = z.infer<typeof ConnectionWSchema>;

// Get Connection

export const GetConnectionResponseWSchema = z.object({
  connection: ConnectionWSchema.nullable(),
});
export type GetConnectionResponseWDto = z.infer<typeof GetConnectionResponseWSchema>;

// Get Authorization URL

export const GetAuthorizationUrlDataWSchema = z.object({
  connectorId: ConnectorIdSchema,
  embedUrl: z.string().nullable(),
  xpsRedirectUrl: z.string().url(),
  context: z.record(z.unknown()).optional(),
});
export type GetAuthorizationUrlDataWDto = z.infer<typeof GetAuthorizationUrlDataWSchema>;

export const GetAuthorizationUrlResponseWSchema = z.object({
  authorizationUrl: z.string(),
});
export type GetAuthorizationUrlResponseWDto = z.infer<typeof GetAuthorizationUrlResponseWSchema>;
